import React, { Fragment } from 'react';
import { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import NavLink from 'react-router-dom/NavLink';
import InquiriesContent from '../../components/account/InquirieContent';
import InquiriesContent1 from '../../components/account/InquirieContent1';
import NoticeCustomContent from '../../components/account/NoticeCustomContent';
import RuleContent from '../../components/account/RuleContent';


const Inquiries = (props) => {
    const [type, setType] = useState(1);
    const onResetType = (val) => {
        setType(val)
      };
      useEffect(()=> {
        onResetType(1)
      }, [])


      const { match } = props;

    return (
       <Fragment>
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">고객센터</div>
                </div>
            </div>
          <div className="contents_wrap">
            <div className="contents_box">
              <div className="con_box00">
                <div className="tab_wrap">
                  <ul>
                  <li><NavLink className="tab" activeClassName="tabon" to={`${match.url}/question`}>1:1문의</NavLink></li>
                  <li><NavLink className="tab" activeClassName="tabon" to={`${match.url}/questionlist`}>Q&A</NavLink></li>
                  <li><NavLink className="tab" activeClassName="tabon" to={`${match.url}/rule`}>베팅규정</NavLink></li>
                  {/* <li><NavLink className="tab" activeClassName="tabon" to={`${match.url}/notices`}>공지사항</NavLink></li> */}
                  </ul>
                </div>
              </div>
                <Switch>
                    <Route path={`${match.url}/question`} component={InquiriesContent}/>
                    <Route path={`${match.url}/questionlist`} component={InquiriesContent1}/>
                    <Route path={`${match.url}/rule`} component={RuleContent}/>
                    {/* <Route path={`${match.url}/notices`} component={NoticeCustomContent}/> */}
                </Switch>
            </div>
          </div>
       </Fragment>
    );
};

export default Inquiries;


// WEBPACK FOOTER //
// ./src/containers/Account/Inquiries.js